import { faPlay } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CameraPlayer from 'src/features/cameras/components/CameraPlayer.tsx';
import {
    Dialog,
    DialogContent,
    DialogHead,
    DialogHeader,
    DialogSeparator,
    DialogTitle,
    DialogTrigger,
} from 'src/registry/ui/Dialog.tsx';
import { cn } from 'src/utils';

import type { Camera } from 'src/features/cameras/types/camera.ts';

type Props = {
    camera: Camera;
    preview: string;
    index: number;
};

export default function CameraTile(props: Props) {
    const { camera, preview, index } = props;
    return (
        <Dialog modal>
            <DialogTrigger className="group xs:aspect-auto relative flex aspect-video items-center justify-center overflow-hidden rounded-xl bg-black/50">
                <img
                    src={preview}
                    alt="preview"
                    className={cn(
                        'h-full w-full object-cover blur-xs transition-all group-hover:blur-none',
                        index % 2 === 0 && '-scale-x-100',
                    )}
                />
                <FontAwesomeIcon
                    icon={faPlay}
                    aria-hidden="true"
                    focusable="false"
                    className="absolute size-1/5 text-white transition-transform group-hover:scale-125"
                />
                <div className="xs:text-xs absolute bottom-0 flex h-1/4 w-full items-center justify-center rounded-b-xl bg-black/50 p-2 text-[10px] text-white opacity-80 sm:text-sm">
                    <div className="truncate">{camera.name}</div>
                </div>
            </DialogTrigger>
            <DialogContent className="max-w-7xl">
                <DialogHeader>
                    <DialogHead className="space-y-0">
                        <DialogTitle>{camera.name}</DialogTitle>
                    </DialogHead>
                </DialogHeader>

                <DialogSeparator />
                <CameraPlayer camera={camera} />
            </DialogContent>
        </Dialog>
    );
}
